import { render, staticRenderFns } from "./u-footer-body-basic.vue?vue&type=template&id=64611149&scoped=true"
import script from "./u-footer-body-basic.vue?vue&type=script&lang=js"
export * from "./u-footer-body-basic.vue?vue&type=script&lang=js"
import style0 from "./u-footer-body-basic.vue?vue&type=style&index=0&id=64611149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64611149",
  null
  
)

export default component.exports